import {useEffect} from 'react'
import type {RefObject} from 'react'

// This hook replaces the native `autoFocus` prop to provide safer, more controlled
// focus management. It applies focus after mount (avoiding layout shifts),
// accommodates settings commonly used by accessibility tools like screen readers,
// and allows for conditional control over when focus is applied.

export const useAutoFocus = <T extends HTMLElement>(
    elementRef: RefObject<T>,
    shouldAutoFocus: boolean = false,
) => {
    useEffect(() => {
        if (!shouldAutoFocus || !elementRef.current) {
            return
        }

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        if (!prefersReducedMotion) {
            elementRef.current.focus()
        }
    }, [shouldAutoFocus, elementRef])
}
